<div class="card shadow mb-4 h-100">
  <div class="card-header">
    <div class="d-flex justify-content-between align-items-center" style="height: 40px">
      <div>
        <h3>{{ 'Case creditor status editor' | translate }}</h3>
      </div>
      <div *ngIf="!isEditing" class="col-5 text-right">
        <button mat-icon-button color="primary" (click)="toggleEditMode(true)" class="p-0">
          <mat-icon>settings</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div class="card-body d-flex flex-column">
    <div *ngIf="isLoading" class="d-flex justify-content-center align-items-center">
      <mat-spinner diameter="30" color="primary"></mat-spinner>
    </div>
    <form class="disabled-form" *ngIf="formActive" [hidden]="isLoading" [formGroup]="form"
          (ngSubmit)="submitForm(form)">
      <div *ngFor="let departmentCategory of filteredDepartmentCategories">
        <!--<h3>{{ departmentCategory.name }}</h3>-->
        <div *ngFor="let department of departmentCategory.departments">
          <app-input type="select" appearance="outline" style="display: block" [searchable]="true"
                     [fullWidth]="true" *ngIf="department.active"
                     [formControlName]="department.type" [extraLabel]="true" [selectOptions]="department.users"
                     [selectValue]="'id'" [label]="department.name" [selectLabel]="['first_name', 'last_name']">
          </app-input>
        </div>
      </div>
      <!-- Case Creditor status-->
      <app-input type="select" appearance="outline" style="display: block" [searchable]="true"
                 [fullWidth]="true" formControlName="case_creditor_status_id" [extraLabel]="true" [showLabel]="false"
                 [selectOptions]="caseCreditorStatuses" [selectLabel]="authUser.locale === 'es' ? 'name_es' : 'name_en'"
                 [selectValue]="'id'" [label]="'CASE_CREDITOR.model.response_received.label' | translate">
      </app-input>
      <!-- Request debt settlement -->
      <div class="row mt-2 mb-2">
        <div class="col d-flex flex-column justify-content-center">{{ 'Request debt settlement' | translate }}</div>
        <div class="col d-flex flex-row justify-content-end">
          <button type="button" mat-icon-button color="primary"
                  *ngIf="caseCreditor.case_creditor_status?.slug !== 'ds_settlement_requested'"
                  [disabled]="caseCreditor.case_creditor_status?.slug === 'ds_settled'"
                  (click)="requestDebtSettlement($event, caseCreditor, case)">
            <mat-icon>send</mat-icon>
          </button>
        </div>
      </div>
      <!-- Top up modal -->
      <div class="row mt-2 mb-2">
        <div class="col d-flex flex-column justify-content-center">{{ 'Top up calculator' | translate }}</div>
        <div class="col d-flex flex-row justify-content-end">
          <button type="button" mat-icon-button color="primary" (click)="openCalculationModal($event, caseCreditor)"
                  class="p-0">
            <mat-icon>euro_symbol</mat-icon>
          </button>
        </div>
      </div>

      <div *ngIf="isEditing" class="row pt-3">
        <div class="col-12 text-right">
          <button mat-button color="primary" class="mr-3" (click)="toggleEditMode(false)">
            {{ 'SHARED.cancel' | translate }}
          </button>
          <app-spinner-btn type="submit" [loading]="isSubmitting" [disabled]="!isElementRestricted()" color="primary">
            {{ 'SHARED.save' | translate }}
          </app-spinner-btn>
        </div>
      </div>
    </form>
  </div>
</div>
